import { useDisclosure, VStack } from '@chakra-ui/react';
import { type FC, useState } from 'react';

import { DeleteStudentModal } from '$/pages/StudentsPage/components/DeleteStudentModal';
import { EditStudentModal } from '$/pages/StudentsPage/components/EditStudentModal';
import { StudentCard } from '$/pages/StudentsPage/components/StudentCard';
import { type User } from '$/services/usecases/authentication/mapper/genericCloudResponse';
import { type SchoolClass } from '$/services/usecases/school/mapper/schoolClasses';

interface Props {
  students: User[];
  schoolClassOptions: SchoolClass[];
}

export const StudentCardList: FC<Props> = ({
  students,
  schoolClassOptions,
}) => {
  const editModal = useDisclosure();
  const deleteModal = useDisclosure();
  const [selectedStudent, setSelectedStudent] = useState<User | null>(null);

  const handleEdit = (student: User) => {
    setSelectedStudent(student);
    editModal.onOpen();
  };

  const handleDelete = (student: User) => {
    setSelectedStudent(student);
    deleteModal.onOpen();
  };

  const handleEditClose = () => {
    editModal.onClose();
    setSelectedStudent(null);
  };

  const handleDeleteClose = () => {
    deleteModal.onClose();
    setSelectedStudent(null);
  };

  return (
    <>
      <VStack w='full'>
        {students.map((student) => (
          <StudentCard
            key={student.id}
            student={student}
            className={
              schoolClassOptions.find(
                (schoolClass) => schoolClass.id === student.classId,
              )?.name
            }
            onEdit={handleEdit}
            onDelete={handleDelete}
          />
        ))}
      </VStack>

      {selectedStudent != null && (
        <>
          <EditStudentModal
            student={selectedStudent}
            isOpen={editModal.isOpen}
            onClose={handleEditClose}
            schoolClassOptions={schoolClassOptions}
          />
          <DeleteStudentModal
            student={selectedStudent}
            isOpen={deleteModal.isOpen}
            onClose={handleDeleteClose}
          />
        </>
      )}
    </>
  );
};
